import { useRef, useState } from 'react';
import { useChallenge } from 'src/hook/data/useChallenge';
import { useComponentModal } from 'src/hook/modal/useComponentModal';
import { PageSource } from 'src/model/enum/enums';
import { IconLocation } from 'src/utils/URLUtils';
import { Word } from '../../../model/Word';
import { Sense } from '../../../model/WordData';
import styles from './ImageSection.module.scss';
import MoreOptionsMenu from './MoreOptionsMenu/MoreOptionsMenu';
import VideoSection from './VideoSection/VideoSection';

interface ImageSectionProps {
    word: Word;
    sense: Sense;
    source?: PageSource;
}

const ImageSection = ({ word, sense, source }: ImageSectionProps) => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const moreOptionsRef = useRef<HTMLSpanElement>(null);
    const { startClosing } = useComponentModal();
    const { setAutoPlay } = useChallenge();

    const handleClose = () => {
        if (source === PageSource.Learn) {
            setAutoPlay(false);
        }
        else {
            setAutoPlay(true);
        }
        startClosing();
    };

    return (
        <section className={styles.imageSection}>
            <VideoSection sense={sense} word={word} />
            <span ref={moreOptionsRef} onClick={() => setIsMenuOpen(!isMenuOpen)}
                className={styles.moreOptions}>•••</span>
            <span onClick={handleClose}
                className={styles.close}>
                <img src={IconLocation('x')} alt="close" />
            </span>
            <MoreOptionsMenu
                isOpen={isMenuOpen}
                onClose={() => setIsMenuOpen(false)}
                trigger={moreOptionsRef.current}
                word={word}
                senseId={sense.id}
            />
        </section>
    );
};

export default ImageSection;